import type { AuthorizationState, RequestContext } from "./types";
import { AUTH_MESSAGES, isIdentifier } from "../../../../api/newAuthorization";
import type { LoginFormState } from "../../../../store/loginFormStore";
import { useAuthorizationStore } from "../../../../store/authorizationStore";
import { ESMSFormState } from "../../../../store/slices/smsFormSliceCreator";

interface SmsContext extends RequestContext {
  auth: Pick<AuthorizationState, "otpSessionUuid" | "restoringPin">;
  login: Pick<LoginFormState, "smsCode" | "setSMSFormState">;
}

export async function verifySms({ auth, login, request, isCurrent, navigate }: SmsContext) {
  if (!auth.otpSessionUuid) {
    throw new Error(AUTH_MESSAGES.sms);
  }

  const data = await request(`/otps/${encodeURIComponent(auth.otpSessionUuid)}/verification`, { otpCode: login.smsCode });
  if (!isCurrent()) {
    return;
  }

  if (!isIdentifier(data.authSessionId) || (data.flow !== "REG" && data.flow !== "AUTH")) {
    throw new Error(AUTH_MESSAGES.sms);
  }

  useAuthorizationStore.setState({ authSessionId: data.authSessionId, flow: data.flow, passportChecked: false });
  login.setSMSFormState(ESMSFormState.submitted);
  navigate(data.flow === "REG" ? "/login/passport" : "/login/pin", { replace: true });
}
